<template>
  <div class="bank-pay-wrpper">
    <div class="content">
      <p class="bank-title">网商银行资金分账授权</p>
      <p class="bank-desc">
        为了给您提供合规、透明的资金结算服务，根据业务需求，您需要预先完成
        网商银行资金分账功能 的授权
      </p>
      <div class="auth-ul">
        <p>
          <span class="weight">为何需要授权？</span>
          <span class="text"
            >授权后，系统才能根据订单信息，自动、准确地将款项分账到渠道方，确保资金结算清晰、高效。</span
          >
        </p>
        <p>
          <span class="weight">授权是否安全？</span>
          <span class="text"
            >由网商银行直接校验，全程受到金融机构级别安全协议的保护，充分保障账户信息与资本安全</span
          >
        </p>
      </div>
      <p class="bank-desc">整个授权签约流程将在支付宝-网商银行页面完成</p>
      <div class="alipay-authorize">
        <div class="left">
          <img
            v-if="!qrCode"
            src="@/assets/image/common/erweima.png"
            style="width: 130px; height: 130px"
          />
          
          <div v-else id="qrCode" ref="qrCodeRef"></div>
          <!-- <img
            v-else
            :src="qrCode"
            style="width: 130px; height: 130px"
          /> -->
          <p class="bank-desc" style="margin-top: 16px">
            网商银行授权签约二维码
          </p>
        </div>
        <div class="right">
          <p class="bank-step">网商银行-授权签约流程</p>
          <p class="bank-desc">
            1.请公司法人打开 【<span style="color: #256bff">支付宝</span
            >】，扫一扫左侧授权签约二维码
          </p>
          <img
            src="@/assets/image/common/zhifubao.png"
            alt=""
            style="height: 137px; margin-bottom: 16px"
          />
          <p class="bank-desc">2.签约协议并完成身份核验，即可签约完成</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPartnerAuthSignApi } from '@/utils/api/zhenyun.js'
import QRCode from 'qrcodejs2'
export default {
  name: 'ComponentName',
  props: [],
  data() {
    return {
      qrCode: '',
      isMask:false,
      qrCodeInstance:null
    }
  },
  methods: {
    async getQRcode() {
      try {
        const res = await getPartnerAuthSignApi()
        const { rspResult, data } = res
        if (rspResult.bizCode == 200) {
          this.qrCode = data.value
          this.$nextTick(() => {
            this.newQRCode()
          })
        }
      } catch (error) {}
    },
    async newQRCode() {
      try {
        this.$refs.qrCodeRef.innerHTML = ''
        this.qrCodeInstance = new QRCode(this.$refs.qrCodeRef, {
          text: this.qrCode, // 需要转换为二维码的内容
          width: 130,
          height: 130,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.L,
        })
      } catch (err) {
        console.error('❌ ~ file: payment.js:182 ~ newQRCode ~ err:', err)
        this.isMask = true
      }
    },
  },
  mounted() {
    this.getQRcode()
    // 移除全局样式 haizol-main-wrapper 对本页面的影响
    const mainWrapper = document.querySelector('.haizol-main-wrapper')
    if (mainWrapper) {
      mainWrapper.classList.remove('haizol-main-wrapper')
      this.mainWrapperEl = mainWrapper
    }
  },
  beforeDestroy() {
    // 离开页面时恢复全局样式
    if (this.mainWrapperEl) {
      this.mainWrapperEl.classList.add('haizol-main-wrapper')
    }
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.bank-pay-wrpper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  .content {
    // width: 1000px;
    background: #fff;
    padding: 40px 120px;
    .bank-title {
      font-size: 16px;
      color: #303133;
      font-weight: 700;
      margin-bottom: 24px;
    }
    .bank-desc {
      font-size: 14px;
      color: #606266;
      line-height: 24px;
      margin-bottom: 16px;
    }
    .auth-ul {
      font-size: 14px;
      color: #606266;
      margin-bottom: 16px;
      .weight {
        font-weight: 700;
        color: #303133;
      }
    }
    .alipay-authorize {
      display: flex;
      align-items: flex-end;
      .left {
        margin-right: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .right {
        .bank-step {
          font-size: 14px;
          color: #303133;
          font-weight: 500;
          margin-bottom: 16px;
        }
      }
    }
  }
}
</style>
